import { appConfig } from '../config.js'
import _ from 'lodash'

export const Getters = {
  getInsurerCardColor: state => {
    return state.insurerCardColor
  },
  getCameraCount: state => {
    return state.cameraCount
  },
  ceStatuses: state => {
    return state.ceStatuses
  },
  getPartsSearchLocations: state => {
    return state.partsSearchLocations
  },
  getPlannerBoardType: state => {
    return state.plannerBoardType
  },
  getVehicleMakes: state => {
    let makes = []
    for (let make in state.vehicleMakeModels) {
      makes.push(make)
    }
    return makes
  },
  getVehicleModels: state => {
    let models = []
    for (let make in state.vehicleMakeModels) {
      for (let model in state.vehicleMakeModels[make].data) {
        models.push({
          make: make,
          model: model,
        })
      }
    }
    return models
  },
  getVehicleSeries: state => {
    let seriesArray = []
    for (let make in state.vehicleMakeModels) {
      for (let model in state.vehicleMakeModels[make].data) {
        for (let series in state.vehicleMakeModels[make].data[model].data) {
          seriesArray.push({
            make: make,
            model: model,
            series: series,
          })
        }
      }
    }
    return seriesArray
  },
  isStatusActive: state => {
    return state.vendorInfo.isActive
  },
  estimateMethodologies: (state, getters) => {
    if (state.vendorInfo && Array.isArray(state.vendorInfo.schedules) && state.vendorInfo.schedules.length > 0) {
      return state.vendorInfo.schedules
    }

    let em = [
      { key: 'custom', value: 'Custom' },
      { key: 'ntar', value: 'NTAR' },
      { key: 'ltar', value: 'LTAR' },
      { key: 'zi', value: 'Zurich' },
      { key: 'dollars', value: 'Dollars' },
    ]

    if (getters.isRsEnabled) {
      em.push({ key: 'rs', value: 'RS' })
    }

    return em
  },
  isFreePlan: state => { return state.vendorInfo.planId == 0 },
  isBasicPlan: state => { return Number(state.vendorInfo.planId) === 10 },
  isPremiumPlan: state => { return Number(state.vendorInfo.planId) === 11 },
  isMultisitePlan: state => { return Number(state.vendorInfo.planId) === 12 },
  isRsEnabled: state => Boolean(state.vendorInfo.isRsEnabled),
  isScheduleAvailable: (state,getters) =>{return (Boolean(state.vendorInfo.isScheduleAvailable) || (getters.isBasicPlan ||getters.isPremiumPlan ||getters.isMultisitePlan ))},
  isScheduleEditable: (state,getters) =>{return (Boolean(state.vendorInfo.isScheduleAvailable) || (getters.isPremiumPlan ||getters.isMultisitePlan ))},
  isLogoutAction: state => state.isLogout,
  authToken: state => state.token,
  isLoggedIn: state => Boolean(state.token && state.token !== undefined && state.token !== 'undefined' && state.token.length > 1),
  isCanUpdate: state => state.isCanUpdate,
  authStatus: state => state.status,
  addressStates: state => {
    return state.addressStates
  },
  addressCountries: state => {
    return state.addressCountries
  },
  vehicleTransmissions: state => {
    return state.vehicleTransmissions
  },
  vehicleTransmissionsCaravan: state => {
    return state.vehicleTransmissionsCaravan
  },
  butterflyCategories: state => {
    return state.butterfly.categories
  },
  butterflyMatrix: state => {
    return state.butterfly.matrix
  },
  butterflyCustomMatrix: state => {
    return state.butterfly.customMatrix
  },
  butterflyMatrixOrder: state => {
    return state.butterfly.matrixOrder
  },
  butterflySubcategories: state => {
    return state.butterfly.names
  },
  getMenu: state => {
    return state.menu
  },
  butterflyBodies: state => {
    return state.butterfly.bodies
  },
  fileIdsInCardEdit: state => {
    return state.fileIdsInCardEdit
  },
  cardFilter: state => {
    return state.filter.card
  },
  invoiceFilter: state => {
    return state.filter.invoice
  },
  isJustSeeMine: state => {
    return !!(state.userInfo && state.userInfo.isJustSeeMine)
  },
  estimateFilter: state => {
    return state.filter.estimate
  },
  userId: state => {
    return Number(state.userInfo.user_id)
  },
  thumbHash: state => {
    return state.userInfo?.thumbHash
  },
  userInfo: state => {
    return state.userInfo
  },
  vendorInfo: state => {
    return state.vendorInfo
  },
  vendorId: state => {
    return state.vendorInfo?.vendor_id
  },
  isPrimaryMultiAccount: state => {
    return (state.vendorInfo?.isPrimaryMultiAccount === true)
  },
  isSecondaryMultiAccount: state => {
    return (state.vendorInfo?.isSecondaryMultiAccount === true)
  },
  getPrimaryMultiAccountName: state => {
    return state.vendorInfo?.primaryMultiAccountName || ''
  },
  isAiCopilotFullyInActive: state => {
    const ai = state.vendorInfo?.ai?.copilot || {}
    return Boolean(!ai.damage?.active && !ai.partsInfo?.active && !ai.vehicle?.active)
  },
  isAiCopilotDamageDisabled: state => {
    return Boolean(!state.vendorInfo?.ai?.copilot?.damage?.active)
  },
  isAiCopilotPartsInfoDisabled: state => {
    return Boolean(!state.vendorInfo?.ai?.copilot?.partsInfo?.active)
  },
  isAiCopilotVehicleDisabled: state => {
    return Boolean(!state.vendorInfo?.ai?.copilot?.vehicle?.active)
  },
  getBusinessName: state => {
    return (state.vendorInfo && state.vendorInfo.display_name) ? state.vendorInfo.display_name : state.vendorInfo.business_name
  },
  isShowBusinessName: state => {
    return state.vendorInfo.vendor_id != 13
  },
  avatar: state => {
    if (state.userInfo && state.userInfo.avatar) {
      return state.userInfo.avatar
    }
    return appConfig.baseAPIURL + '/img/avatars/default-avatar.jpg'
  },
  activeUsers: state => {
    let users = _.filter(state.users, (u) => {
      return (u.isActive === true)
    })
    return users
  },
  visibleUsers: state => {
    // let users = _.filter(state.users, (u) => {
    //     return (u.isActive === true && u.isVisible);
    // });
    let users = _.filter(state.users, (u) => {
      return (u.isActive === true)
    })
    return users
  },
  users: state => {
    return state.users
  },
  partCategories: state => {
    return state.partCategories
  },
  roles: state => {
    return state.roles
  },
  filesInCardEditGetter: state => {
    return state.filesInCardEdit
  },
  isUserMultiSite: state => {
    return (state.userInfo?.multiSite && state.userInfo?.multiSite.length > 1)
  },
  getMultiSites: state => {
    return state.userInfo?.multiSite || []
  },
  isShopManagerUser: state => {
    return !_.isEmpty(state.userInfo) && Number(state.userInfo.group_id) === 2
  },
  isAdministrator: state => {
    return false
  },
  isProductionManagerUser: state => {
    return !_.isEmpty(state.userInfo) && Number(state.userInfo.group_id) === 10
  },
  isEstimatorUser: state => {
    return !_.isEmpty(state.userInfo) && (Number(state.userInfo.group_id) === 3 || Number(state.userInfo.group_id) === -1)
  },
  isPDRTechnicianUser: state => {
    return !_.isEmpty(state.userInfo) && Number(state.userInfo.group_id) === 20
  },
  isTechnicalUser: state => {
    return !_.isEmpty(state.userInfo) && Number(state.userInfo.group_id) === 4
  },
  isPanelTechnicianUser: state => {
    return !_.isEmpty(state.userInfo) && Number(state.userInfo.group_id) === 4
  },
  isPaintTechnicianUser: state => {
    return !_.isEmpty(state.userInfo) && Number(state.userInfo.group_id) === 6
  },
  isCustomerUser: state => {
    return !_.isEmpty(state.userInfo) && Number(state.userInfo.group_id) === 5
  },
  isStripperFitterUser: state => {
    return !_.isEmpty(state.userInfo) && Number(state.userInfo.group_id) === 7
  },
  isDetailerUser: state => {
    return !_.isEmpty(state.userInfo) && Number(state.userInfo.group_id) === 8
  },
  isDisplayBoardUser: state => {
    return !_.isEmpty(state.userInfo) && Number(state.userInfo.group_id) === 200
  },
  totalFiles: state => {
    return state.filesInCardEdit.length
  },

  updateDataGetter: state => {
    return state.updateData
  },

  cards: state => {
    return state.cards
  },
  scannerApiKey: state => {
    return state.scannerApiKey
  },
  pcs: state => {
    return state.pcs
  },
  getAllCustomers: state => {
    return state.customerVehicles
  },
  lastTimeForCards: state => {
    return state.lastTimeForCards
  },
  isVendorBranding: state => {
    return state.vendorInfo.isBranding
  },
  getVendorBrandingType: state => {
    return state.vendorInfo.brandingType
  },
  isBusinessTypeBikeRepairer: state => {
    return Number(state.vendorInfo?.business_type_id) === 4
  },
  isBusinessTypeCaravanRepairer: state => {
    return Number(state.vendorInfo?.business_type_id) === 7
  },
  isAiActive: state => {
    // console.log('isAiActive', state.vendorInfo)
    return state.vendorInfo?.ai?.copilot?.vehicle?.active || false
  },
  getSavedCards: state => state.vendorInfo?.stripeCards || [],
  isImportPdfAiActive: state => {
    return (state.vendorInfo?.vendor_id == 4 || state.vendorInfo?.vendor_id == 95)
  },
  getBrandingClass: (state, getters) => {
    if (getters['isBrandingSouthernCross'] && getters['isBrandingSouthernCross'] === true) { return 'branding-SCSR'}
    if (getters['isBrandingPAW'] && getters['isBrandingPAW'] === true) { return 'branding-PAW'}
    if (getters['isBranding5SP'] && getters['isBranding5SP'] === true) { return 'branding-5SP'}
    return ''
  },
  isBranding: (state, getters) => {
    return ((getters['isBrandingSouthernCross'] && getters['isBrandingSouthernCross'] == true)
      || (getters['isBrandingPAW'] && getters['isBrandingPAW'] == true)
      || (getters['isBranding5SP'] && getters['isBranding5SP'] == true))
  },
  isBrandingSouthernCross: (state) => {
    return (state.vendorInfo?.isBrandingSouthernCross)
  },
  isBrandingPAW: (state) => {
    return (state.vendorInfo?.isBrandingPrestigeAutoWorks)
  },
  isBranding5SP: (state) => {
    return (state.vendorInfo?.isBrandingFiveStarPanels)
  },
  isCanShare: (state, getters) => {
    return (getters['isSecondaryMultiAccount'] && getters['isSecondaryMultiAccount'] === true)
    // return (state.vendorInfo?.vendor_id  == 8
    //   || state.vendorInfo?.vendor_id  == 50
    //   || state.vendorInfo?.vendor_id == 60
    //   || state.vendorInfo?.vendor_id == 44
    //   || state.vendorInfo?.vendor_id ==98
    //   || state.vendorInfo?.vendor_id ==99
    //   || state.vendorInfo?.vendor_id ==109
    //   || state.vendorInfo?.vendor_id ==13
    //   || state.vendorInfo?.vendor_id ==39)
  },
  isShowAssessmentRepxTab: (state) => {
    return (state.vendorInfo?.vendor_id == 4
      || state.vendorInfo?.vendor_id == 38
      || state.vendorInfo?.vendor_id == 50
      || state.vendorInfo?.vendor_id == 112
    )
  },
  isShowJobTypeCash: (state)=>{
    return state.vendorInfo?.isJobTypeCashAvailable
  }
}
